<template>
<card>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="addObjek">
            <b-container fluid="sm">
                <h6 class="heading-small text-muted mb-4">Profil Pengguna</h6>

                <div class="pl-lg-4">

                    <!-- <b-form-row>
                        <b-col>
                            <base-input id="CONm" label="Nama" placeholder="" v-model="objek.Nama" :rules="{ required: true }" name="Nama" />
                        </b-col>
                    </b-form-row> -->
                    <b-form-row>
                        <b-col>
                            <base-input id="ICNo" label="No Kad Pengenalan" placeholder="" v-model="objek.NoKP" :rules="{ required: true }" name="No Kad Pengenalan" />
                        </b-col>
                    </b-form-row>
                </div>
                <hr class="my-4">

                <!-- Address -->
                <h6 class="heading-small text-muted mb-4">Tetapan Pengguna</h6>

                <div class="pl-lg-4">
                    <b-row>
                        <b-col md="6">
                            <base-input label="Peranan">
                                <select class="form-control" v-model="objek.roleID">
                                    <option value="1">Pengguna Asas</option>
                                    <option value="2">Pegawai BGE, JPA</option>
                                    <option value="3">Pentadbir Sistem</option>
                                    <option value="4">Pegawai PSM Kementerian/Agensi</option>
                                </select>
                            </base-input>
                        </b-col>
                    </b-row>

                    <b-form-row>
                        <b-col>
                            <b-form-group label="Status">
                                <b-form-checkbox name="status" v-model="objek.StatusAktif" value="1" unchecked-value="0" switch>

                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                </div>
                <hr class="my-4">

                <!-- Button -->
                <div class="pl-lg-4">
                    <b-row>
                        <b-col md="12" class="text-md-right">
                            <b-button size="md" variant="success" type="submit" :disabled="invalid">SIMPAN</b-button>

                            <b-button size="md" variant="danger" @click="batal()">BATAL</b-button>
                        </b-col>
                    </b-row>
                </div>

            </b-container>
        </b-form>
    </validation-observer>
</card>
</template>

<script>
import swal from "sweetalert2";
import PenggunaService from "@/services/PenggunaService.js";
export default {
    data() {
        return {
            objek: {},
        }
    },
    methods: {
        addObjek() {
            console.log("addObjek: ", this.objek);

            PenggunaService.setTambahPengguna(this.objek)
                .then((resp) => {
                    this.StatusSimpan = resp.data;
            }).then(() => {
                    // console.log(resp.data)
                    if (this.StatusSimpan.Status == 1) {
                    swal
                        .fire({
                            title: "BERJAYA DI SIMPAN!",
                            text: "CLICK OK UNTUK TERUSKAN.",
                            icon: "success",
                        })
                        .then(() => {
                            this.$emit("refreshPaging");
                            this.$emit("batal");
                        });
                } else {
                    swal.fire({
                        title: this.StatusSimpan.details,
                        text: "CLICK OK UNTUK TERUSKAN.",
                        icon: "error",
                    }).then(() => {
                        this.$emit("refreshPaging");
                        this.batal();
                    });
                }
                })
                //     swal.fire({
                //         title: `Kemaskini Berjaya`,
                //         text: "",
                //         buttonsStyling: true,
                //         icon: "success",
                //     });

                //     this.$emit("refreshPaging");
                //     this.batal();
                // })
                .catch((err) => {
                    console.error(err);
                });
        },
        batal() {

            this.$emit('batal')
        },

    },
    computed: {},
}
</script>
